import { Printer, CheckCircle } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { BrandMark } from "@/components/Brand";
import { money, shortDate } from "@/lib/format";

function Row({ k, v, strong, testId }) {
  return (
    <div className="flex items-center justify-between py-2.5 text-sm">
      <span className="text-mist">{k}</span>
      <span data-testid={testId} className={strong ? "font-semibold text-ink" : "text-ink"}>{v}</span>
    </div>
  );
}

export function ReceiptDialog({ receipt: r, open, onOpenChange }) {
  if (!r) return null;
  const discount = r.original_amount - r.amount;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="receipt-dialog" className="max-w-md rounded-3xl p-8 print:shadow-none">
        <DialogHeader className="text-left">
          <div className="mb-3 flex items-center gap-2"><BrandMark size={28} /><span className="font-display font-semibold text-ink">SpeakToPrompt</span></div>
          <DialogTitle className="font-display text-2xl font-semibold text-ink">Receipt</DialogTitle>
          <DialogDescription className="text-xs text-mist">{r.number} · {shortDate(r.created_at)}</DialogDescription>
        </DialogHeader>
        <div className="divide-y divide-black/5 border-y border-black/5">
          <Row k="Billed to" v={r.email} />
          <Row k="Plan" v={`${r.plan_label} · ${r.interval === "yearly" ? "Yearly" : "Monthly"}`} />
          <Row k="Price" v={money(r.original_amount, r.currency)} />
          {discount > 0 && <Row k={`Discount (${r.sale_code || "sale"} · ${r.sale_percent}% off)`} v={`−${money(discount, r.currency)}`} testId="receipt-discount" />}
          <Row k="Total paid" v={money(r.amount, r.currency)} strong testId="receipt-total" />
          <Row k="Paid with" v={r.provider === "razorpay" ? "Razorpay" : "Card (Stripe)"} />
          <Row k="Valid until" v={shortDate(r.valid_until)} />
          <Row k="Reference" v={<span className="font-mono text-xs">{r.payment_ref}</span>} />
        </div>
        <div className="flex items-center justify-between">
          <span className="flex items-center gap-1.5 text-xs text-mist">
            {r.emailed && <><CheckCircle size={14} weight="fill" className="text-[#34C759]" /> Emailed to you</>}
          </span>
          <button data-testid="receipt-print-button" onClick={() => window.print()} className="flex h-10 items-center gap-2 rounded-full bg-ink px-5 text-sm font-semibold text-white hover:bg-black">
            <Printer size={15} /> Print / Save PDF
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
